import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Instagram, Linkedin, Mail, MapPin, Phone } from 'lucide-react';
import { COMPANY, NAV, ACCREDITATIONS, PARTNERS } from '../data/mock';
import { subscribe } from '../lib/api';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try { await subscribe(email); } catch {}
    setSent(true); setTimeout(() => setSent(false), 4000);
    setEmail('');
  };

  return (
    <footer className="bg-[var(--navy)] text-white">
      {/* Partners ticker */}
      <div className="border-b border-white/10 py-10">
        <div className="container-rs grid md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-3 font-tag opacity-70">— Trusted by</div>
          <div className="md:col-span-9 flex flex-wrap gap-x-10 gap-y-4">
            {PARTNERS.map((p) => (
              <span key={p} className="font-display text-2xl md:text-3xl opacity-70 hover:opacity-100 transition-opacity">{p}</span>
            ))}
          </div>
        </div>
      </div>

      <div className="container-rs pt-24 pb-10">
        <div className="grid lg:grid-cols-12 gap-14">
          <div className="lg:col-span-6">
            <div className="font-tag opacity-70">— Newsletter</div>
            <h3 className="font-display text-5xl md:text-7xl mt-5 leading-[0.95]">Built quarterly<br /><span className="font-display-italic text-[var(--coral)]">briefings.</span></h3>
            <p className="mt-6 max-w-md opacity-70">A short letter four times a year. New work, awards and the occasional studio dispatch from the Shropshire mill.</p>
            <form onSubmit={submit} className="mt-8 flex items-center gap-3 max-w-lg">
              <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required placeholder="your@email.com" className="flex-1 bg-transparent border-b border-white/30 focus:border-[var(--coral)] outline-none py-3 placeholder:text-white/40 transition-colors" />
              <button type="submit" className="pill pill-coral"><span>Subscribe</span><ArrowUpRight size={14} /></button>
            </form>
            {sent && <div className="mt-4 font-tag text-[var(--coral)]">Thank you — you're on the list.</div>}
          </div>

          <div className="lg:col-span-2">
            <div className="font-tag opacity-50 mb-5">Studio</div>
            <ul className="space-y-3 text-[14px]">
              {NAV.map((n) => <li key={n.path}><Link to={n.path} className="u-link">{n.label}</Link></li>)}
              <li><Link to="/testimonials" className="u-link">Testimonials</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="font-tag opacity-50 mb-5">Get in touch</div>
            <ul className="space-y-4 text-[14px]">
              <li className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 text-[var(--coral)]" /><span className="opacity-90">{COMPANY.address}</span></li>
              <li className="flex items-center gap-3"><Phone size={16} className="text-[var(--coral)]" /><a href={`tel:${COMPANY.phoneTel}`} className="u-link">{COMPANY.phone}</a></li>
              <li className="flex items-center gap-3"><Mail size={16} className="text-[var(--coral)]" /><a href={`mailto:${COMPANY.email}`} className="u-link break-all">{COMPANY.email}</a></li>
            </ul>
            <div className="mt-8 flex gap-3">
              <a href={COMPANY.ig} className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-[var(--coral)] hover:border-[var(--coral)] transition-colors" aria-label="Instagram"><Instagram size={15} /></a>
              <a href={COMPANY.li} className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-[var(--coral)] hover:border-[var(--coral)] transition-colors" aria-label="LinkedIn"><Linkedin size={15} /></a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/15 flex flex-wrap items-center gap-3">
          <div className="font-tag opacity-50 mr-3">Accreditations</div>
          {ACCREDITATIONS.map((a) => (
            <span key={a} className="award-pill opacity-80 hover:opacity-100 transition-opacity">{a}</span>
          ))}
        </div>

        <div className="mt-16 flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div className="font-display text-[20vw] md:text-[14vw] leading-[0.85] text-white">
            BESPOKE<span className="text-[var(--coral)]">.</span>
          </div>
        </div>
        <div className="mt-6 flex flex-wrap items-center gap-6 font-tag opacity-60">
          <span>© {new Date().getFullYear()} — {COMPANY.legal}</span>
          <Link to="#privacy" className="u-link">Privacy Policy</Link>
          <Link to="#statements" className="u-link">Statements</Link>
          <span className="ml-auto">{COMPANY.tagline}</span>
        </div>
      </div>
    </footer>
  );
}
